<template>
        <router-view></router-view>
</template>

<script>
    export default{
      name: 'APP'
    }
</script>



// WEBPACK FOOTER //
// App.vue?3745e4ac